import { Component } from '@angular/core';
import { ShowComponent } from '../../common/component/show.component';

@Component({
	selector: 'app-user',
	templateUrl: './user.component.html',
	styleUrls: ['./user.component.css'],
})
export class UserComponent extends ShowComponent {
	protected itemsBeforeDataLoad = 1;
	protected parentComponent = 'users';
	parameters = {
		groups: [],
	};
	data = {
		id: null,
		email: null,
		firstName: null,
		lastName: null,
		name: null,
		groups: [],
		status: 1,
	};

	protected loadBefore() {
		this.api.get('/usersGroups/', (result, error) => {
			this.parameters.groups = result.data;
			this.loadData();
		});
	}
}
